export { EditPhoto } from "./EditPhoto";
